<template>
  <div class="order">
    <ListPageLayout :loading="tableLoading">
    <template #filter>
        <div class="searchbox order_searchbox">
              <form action="#" method="get" class="form-inline form-float">
                <div class="form-group">
                  <input
                  placeholder="请输入车牌号"
                    v-model="search.carNumber"
                    class="form-control"
                    type="text"
                    size="12"
                  />
                </div>
                <div class="form-group">
                  <el-date-picker
                    clearable
                    value-format="yyyy-MM-dd HH:mm:SS"
                    v-model="search.entryDate"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="进场开始时间"
                    end-placeholder="进场结束时间"
                  ></el-date-picker>
                </div>
                <div class="form-group">
                  <el-date-picker
                    clearable
                    value-format="yyyy-MM-dd HH:mm:SS"
                    v-model="search.exitDate"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="离场开始时间"
                    end-placeholder="离场结束时间"
                  ></el-date-picker>
                </div>
                <div class="form-group others">
                  <span class="search_btn">
                    <button
                      @click="searchList"
                      type="button"
                      class="btn btn-primary"
                      id="search_btn" :disabled="tableLoading">
              <i v-if="tableLoading" class="el-icon-loading"></i>
              {{ tableLoading ? "查询中..." : "查询" }}
            </button>
                  </span>
                  <span class="download_btn">
                    <el-button type="primary" size="small" @click="downloadExcel" :disabled="exportLoading"
                      ><i v-if="exportLoading" class="el-icon-loading"></i>{{ exportLoading ? "导出中..." : "导出" }}</el-button
                    >
                  </span>
                </div>
              </form>
            </div>
    </template>

      <el-table
              ref="table"
              border
              :data="tableListData.rows"
              height="100%"
              width="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="styleObj"
            >
              <!-- <el-table-column
                show-overflow-tooltip
                type="selection"
                width="55"
              ></el-table-column> -->
              <el-table-column
                show-overflow-tooltip
                label="停车道路"
                prop="parking_name"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="岗位名称"
                prop="area_name"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="150px"
                label="订单号"
                prop="order_num"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                width="150px"
                label="车牌号"
                prop="car_number"
              >
              </el-table-column>
              <el-table-column
                width="150px"
                label="入场时间"
                prop="begin_date"
              ></el-table-column>
              <el-table-column
                width="150px"
                label="离场时间"
                prop="end_date"
              ></el-table-column>

              <el-table-column
                width="150px"
                label="停车时长"
                prop="parking_long_time"
              ></el-table-column>

              <el-table-column
                show-overflow-tooltip
                label="手机号"
                prop="phone"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="金额"
                prop="real_money"
              ></el-table-column>

              <el-table-column
                show-overflow-tooltip
                label="黔通卡"
                prop="attr1"
              ></el-table-column>
              <el-table-column show-overflow-tooltip label="操作" width="250px">
                <template slot-scope="scope">
                  <button
                    type="button"
                    v-bind:class="[
                      scope.row.attr1 === '是' ? 'is-gray' : '',
                      'operate-button',
                    ]"
                    :disabled="scope.row.attr1 === '是'"
                    @click="onVerityEtcBtn(scope.row)"
                  >
                    认证
                  </button>
                  <button
                    type="button"
                    @click="showPhoto(scope.row.platenum_image)"
                    class="photo"
                  >
                    查看图片
                  </button>
                  <button
                    type="button"
                    v-bind:class="[
                      scope.row.attr1 !== '是' ? 'is-gray' : '',
                      'operate-button',
                    ]"
                    :disabled="scope.row.attr1 !== '是'"
                    @click="onEtcPayBtn(scope.row)"
                  >
                    追缴
                  </button>
                </template>
              </el-table-column>
            </el-table>

      <template #pagination>
        <Page v-on:pagination="receivePaginationData"></Page>
      </template>
    </ListPageLayout>
    <!--查看图片-->
        <div ref="imgDialog" class="imgDialog">
          <el-dialog
            ref="show"
            height="80%"
            :visible.sync="photoDialogVisible"
            :show-close="false"
            @closed="hiddenShade"
            @opened="showImg"
          >
            <div slot="footer">
              <span v-show="photoY" ref="spanImg" class="img-container">
                <img ref="img1" src width="50%" height="auto" />
                <img ref="img2" src width="50%" height="auto" />
              </span>
              <span class="photoN" v-show="photoN">暂无图片</span>
            </div>
          </el-dialog>
        </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import { getArrearsList,reqVerifyEtc,reqEtcPay } from "@/api/url";

import Page from "../../commons/page";
import ListPageLayout from '@/page/commons/ListPageLayout.vue';

export default {
  data() {
    return {
      tableLoading: false,
      exportLoading: false,
      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      photoDialogVisible: false,
      photoY: false,
      photoN: false,
      photoShow: false,
      imgList: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        carNumber: "",
        entryDate:[],
        exitDate:[]
      },
      tableListData: {},
    };
  },
  components: {
    ListPageLayout,
    Page,
  },

  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
        const {carNumber,entryDate,exitDate}=this.search
      let params = {
        limit: this.search.pageSize,
        page: curPage,
      };
      if(carNumber){ params={...params,carNumber}}
     
      if(entryDate?.length>0) {params={...params,beginDateStart: entryDate[0],beginDateEnd:entryDate[1]}}
      if(exitDate?.length>0) {params={...params,endDateStart: exitDate[0],endDateEnd:exitDate[1]}}
      this.tableLoading = true;
      this.$get(getArrearsList(), {
        ...params,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = {
          ...data?.data,
          rows: data?.data?.rows ?? {},
        };
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    searchList: function() {
      if (this.tableLoading) return;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },

    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.tableList(this.search.pageNumber);
    },
    showPhoto(url) {
      this.photoDialogVisible = true;
      const urls = url.split(",");

      this.$refs.imgDialog.style.height = "100vh";
      this.$refs.imgDialog.style.width = "100vw";
      this.$refs.imgDialog.style.background = "rgba(0,0,0,0.5)";
      this.$refs.imgDialog.style.position = "fixed";
      this.$refs.imgDialog.style.top = 0 + "px";
      this.$refs.imgDialog.style.left = 0 + "px";

      if (urls.length <= 0) {
        this.photoY = false;
        this.photoN = true;
      } else {
        this.photoY = true;
        this.photoN = false;

        this.$refs.img1.src = urls[0];
        this.$refs.img2.src = urls[1];
      }

      // this.imgDialog.url = url;
      this.$refs.show.open();
      // console.log(img)
      // ctx.drawImage(img,0,0);
      // window.open(url,'_blank');

      // this.imgViewerVisible = true;
      // this.imgList = url.split(",");
      // const m = (e) => {
      //   e.preventDefault();
      // };
      // document.body.style.overflow = "hidden";
      // document.addEventListener("touchmove", m, false); //禁止页面滑动
    },
    hiddenShade() {
      this.$refs.imgDialog.style.height = 0 + "px";
      this.$refs.imgDialog.style.width = 0 + "px";
    },
    showImg() {
      // console.log("6666")
    },
    onVerityEtcBtn(arrear){
      const {pla_id}=arrear

      this.$get(reqVerifyEtc(),{plaId:pla_id}).then(data=>{
        this.tableList(this.search.pageNumber)
        if(data.status===200){
          this.$message({
					type: "success",
					message: "验证成功"
				});
      
        return;
      }
      if(data.status!==200){
        this.$message({
          type:"warning",
          message:data.message
        })
        return;
      }
        
      }).catch(err=>{
        this.$message({
          type:"warning",
          message:err
        })
      })

    },
    onEtcPayBtn(arrear){
      const {order_id}=arrear
      this.$get(reqEtcPay(),{order_id}).then(data=>{
        if(data.status===200){
          this.$message({
					type: "success",
					message: "ETC扣款成功"
				});
        this.tableList(this.search.pageNumber)
        return;
      }
      if(data.status!==200){
        this.$message({
          type:"warning",
          message:data.message
        })
        return;
      }
      }).catch(err=>{
        this.$message({
          type:"warning",
          message:err
        })
      })
    
  },
  downloadExcel() {
    if (this.exportLoading) return;
    const {carNumber,entryDate,exitDate}=this.search
      let params = {};
      if(carNumber){ params={...params,carNumber}}
      if(entryDate?.length>0) {params={...params,beginDateStart: entryDate[0],beginDateEnd:entryDate[1]}}
      if(exitDate?.length>0) {params={...params,endDateStart: exitDate[0],endDateEnd:exitDate[1]}}
      this.exportLoading = true;
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/unpayOrderExport",
        params,
        "欠费列表"
      ).finally(() => {
        this.exportLoading = false;
      });
     
    },
  },

  computed: {},

  created: function() {},
  mounted: function() {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
  },
  watch: {},
};
</script>
<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.searchbox {
  background: #f9f9fb;
  /* height:130px;
          line-height:45px; */
  border-bottom: 10px solid #eff2f7;
  /* height:150px; */
  padding: 10px 10px 0 10px;
}

.refresh {
  display: inline-block;
}

.bread_container {
  display: inline-block !important;
  border: none !important;
  padding: 0 !important;
}

/* .photo{
          width:60px;
          font-size:12px;
          background:#409EFF;
          color:white;
          height:20px;
          line-height:20px;
          
      } */
.imgDialog {
  overflow: hidden;
}
button.photo {
  height: 22px;
  line-height: 22px;
  color: #278cd8;
  background: none;
  font-size: 12px;
  margin-right: 5px;
}

.photoN {
  width: 350px;
  line-height: 300px;
  height: 300px;
  text-align: center;
  display: inline-block;
}

.imgDialog {
  animation: opacity2 3s;
  -webkit-animation: opacity2 3s;
  -moz-animation: opacity2 3s;
}

@keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

button.gray {
  color: gray;
}
.form-group {
  margin-bottom: 10px;
}
</style>
<style>
.order .el-date-editor {
  width: 250px !important;
}

.order .el-date-editor .el-range-input {
  font-size: 12px !important;
}

.order .el-date-editor .el-range-separator {
  font-size: 12px !important;
}

.order .imgDialog .el-dialog__header {
  display: none;
  padding: 0;
}

.order .imgDialog .el-dialog__body {
  padding: 0 !important;
}

.order .imgDialog .el-dialog__footer {
  padding: 0 !important;
}

.order .searchbox .el-select {
  width: 150px !important;
}

.order .order_searchbox .form-control {
  width: 150px;
}
.order .order_searchbox form {
  height: auto;
}

.order .el-dialog {
  margin-top: 10vh !important;
}

/* .el-dropdown-link {
       display: inline-block;;
      cursor: pointer;
      color:white;
      background:#278cd8;
      height:34px;
      border-radius: 5px;
      padding-left:5px;
      font-size: 12px;
      line-height:37px;
      width:90px;
    } */
.order .el-icon-arrow-down {
  font-size: 12px;
}

.order .dowload {
  padding-left: 10px;
  display: inline-block;
}

.order .img-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0 20px 20px;
}

.order img {
  overflow: hidden;
}

.order .img-container img {
  box-sizing: border-box;
  padding-right: 20px;
}

.order .searchbox .form-inline {
  overflow: auto;
}
.order .is-gray {
  color: #666;
  cursor: not-allowed;
}
</style>
<style>
.order .modify-plate .el-input__inner {
  height: 40px;
}
.order .modify-plate .el-select {
  width: 100%;
}
</style>
